/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeleteOAuthAppResponse { 
    /**
     * List of oauth app client ids failed to delete.
     */
    failed?: Array<string>;
    /**
     * List of oauth app client ids deleted successfully.
     */
    succeeded?: Array<string>;
}

